<template>
  <div class="services-sidebar-country">
    <div v-if="country.positions.length === 1 || isIndividualPrice(country)" class="services-sidebar-country__item">
      <img :src="country.img_path" class="--image"/>
      <div class="--name">{{ getLocalization(country.title) }}</div>
      <div class="buy-number-second-part d-flex justify-content-between">
        <div class="--info clean-margin-left">
          <p>{{ getPrice(country) }} &#x20bd;</p>
          <p>{{ formatCount(country.count) }}</p>
          <p v-if="country.positions[0]?.is_splitting">
            {{ getLocalization('Provider') }} {{ country.positions[0].provider_id }}
          </p>
        </div>
        <div class="--button clean-margin-left d-flex align-items-center">
          <button class="button primary buy-number-btn btn-w-77"
                  @click.stop="handleBuyNumber(country.positions[0], country.id)">
            {{ getLocalization('Buy') }}
          </button>
        </div>
      </div>
    </div>

    <div v-else class="services-sidebar-country__item">
      <img :src="country.img_path" class="--image"/>
      <div class="--name">{{ getLocalization(country.title) }}</div>
      <div class="buy-number-second-part">
        <div class="d-flex justify-content-between">
          <div class="--info clean-margin-left clean-margin-left-flex">
            <p>{{ getLocalization('fr.') }} {{ parseFloat(country.min_price).toFixed(2) }} &#x20bd;</p>
            <p>{{ formatCount(country.count) }}</p>
          </div>
          <div>
            <div class="mb-2 btn-w-77 --button">
              <button @click.stop="handleBuyMaxPrice"
                      class="button primary btn-max-price w-100 btn-with-span">
                {{ getLocalization('Buy') }}
                <span class="text-buy-number">
                  {{ getLocalization('Buy for') }} {{ getMaxPrice() }}₽
                </span>
              </button>
            </div>
            <div class="--button">
              <button class="button primary btn-w-77" @click="toggleCountry">
                {{ isOpen ? getLocalization('Hide') : getLocalization('Select') }}
                <img src="/img/svg/common/arrow-down-thin.svg"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isOpen" class="services-sidebar-country__dropdown">
      <div class="services-sidebar-section__filter">
        <div
            :class="[
            currentSort?.type === 'price' ? 'active' : '',
            currentSort?.sortBy === 'bottom' ? 'bottom' : 'top'
          ]"
            @click="sortPositions('price')"
        >
          {{ getLocalization('By price') }}
          <span class="sort-arrow"></span>
        </div>
        <div
            :class="[
            currentSort?.type === 'count' ? 'active' : '',
            currentSort?.sortBy === 'bottom' ? 'bottom' : 'top'
          ]"
            @click="sortPositions('count')"
        >
          {{ getLocalization('By quantity') }}
          <span class="sort-arrow"></span>
        </div>
      </div>
      <table>
        <thead></thead>
        <tbody>
        <tr v-for="position in sortedPositions" :key="position.price">
          <td class="--price">{{ position.price }} &#x20bd;</td>
          <td class="--count text-center">
            <div>{{ getLocalization('Available') }} {{ formatCount(position.count) }}</div>
            <div>{{ getLocalization('Provider') }} {{ position.provider_id }}</div>
          </td>
          <td class="--button" align="right">
            <button class="button primary buy-number-btn"
                    :style="position.is_gold ? 'background-color: gold' : ''"
                    @click.stop="handleBuyNumber(position)">
              {{ getLocalization('Buy') }}
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import de from "vue2-datepicker/locale/es/de";

export default {
  props: {
    country: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedCountryId: {
      type: [Number, null],
      default: null
    },
    individualPrices: Object,
    selectedService: Object,
  },
  data() {
    return {
      currentSort: null
    }
  },
  computed: {
    sortedPositions() {
      if (!this.currentSort) return this.country.positions;

      return [...this.country.positions].sort((a, b) => {
        if (this.currentSort.type === 'price') {
          return this.currentSort.sortBy === 'bottom'
              ? a.price - b.price
              : b.price - a.price;
        } else {
          return this.currentSort.sortBy === 'bottom'
              ? a.count - b.count
              : b.count - a.count;
        }
      });
    }
  },
  methods: {
    isIndividualPrice(country) {
      const key = this.selectedService.id + '|' + country.id;
      return Object.hasOwn(this.individualPrices, key);
    },
    getPrice(country) {
      const key = this.selectedService.id + '|' + country.id;
      if (Object.hasOwn(this.individualPrices, key)) {
        return Number(this.individualPrices[key]).toFixed(2);
      }

      return Number(country.min_price).toFixed(2);
    },
    getLocalization(key) {
      return this.$root.getLocalization
          ? this.$root.getLocalization(key)
          : key;
    },
    formatCount(count) {
      return count > 3
          ? count + ' ' + this.getLocalization('pcs')
          : this.getLocalization('few');
    },
    getMaxPrice() {
      return Math.max(...this.country.positions.map(p => p.price)).toFixed(2);
    },
    toggleCountry() {
      this.$emit('toggle-country', this.country.id);
    },
    handleBuyNumber(position, countryId) {
      let price = position.price;
      const key = this.selectedService.id + '|' + countryId;
      if (Object.hasOwn(this.individualPrices, key)) {
        price = Number(this.individualPrices[key]).toFixed(2);
      }

      this.$emit('buy-number',
          price,
          this.country.activate_org_code,
          null,
          position.provider_id
      );
    },
    handleBuyMaxPrice() {
      this.$emit('buy-number',
          this.getMaxPrice(),
          this.country.activate_org_code
      );
    },
    sortPositions(type) {
      this.currentSort = {
        type,
        sortBy: this.currentSort?.type === type
            ? this.currentSort.sortBy === 'bottom' ? 'top' : 'bottom'
            : 'top'
      };
    }
  }
}
</script>

